module.exports = __webpack_public_path__ + "img/s7-dialog.0c16a0f4.png";